import type { Editor } from 'slate';
import { ReactEditor } from 'slate-react';

export default function focusEditor(editor: Editor) {
    ReactEditor.focus(editor);
}
